﻿import {useEffect} from 'react';
import _ from "underscore";
import type {Supplier} from "../../types/Supplier";
import {SupplierSortByHookTypes} from "../../types/SupplierSortByHookTypes";

export const useSupplierSortByDistance = ({searchSortBy, unsortedSuppliers, sortedSuppliersSetter}: SupplierSortByHookTypes) => {


  // location sorting by distance
  useEffect(() => {
    if (searchSortBy === 'distance' && unsortedSuppliers.length) {
      sortedSuppliersSetter(_.sortBy(unsortedSuppliers, (supplier: Supplier) => parseFloat(supplier.distance || '0')));
    }
  }, [searchSortBy, sortedSuppliersSetter, unsortedSuppliers])
}
